import React from 'react';

export default function Security() {
  return (
    <div className="bg-black text-white min-h-screen px-6 py-10">
      <h1 className="text-3xl font-bold mb-4">Kernel Security Information</h1>

      <p>
        <strong>Effective date: 04-JAN-2024</strong>
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Governance</h2>
      <p>
        Kernel’s Security team establishes policies and controls, monitors
        compliance with those controls, and proves our security and compliance
        to third-party auditors.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">
        Security and Compliance
      </h2>
      <p>
        Kernel has established a continuous SOC 2 Type II policy. Our SOC 2 Type
        II report and details of our controls are available on our Trust Center
        upon request.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Data Protection</h2>
      <h3 className="text-xl mt-4">Data at Rest</h3>
      <p>
        All data stores with customer data are encrypted at rest using EBS-level
        encryption.
      </p>
      <h3 className="text-xl mt-4">Data in Transit</h3>
      <p>
        Kernel uses TLS 1.2 or higher everywhere data is sent over any network.
        SaaS installations utilize a site-to-site VPN or specifically
        whitelisted IP addresses to ensure only users in the customer network
        are allowed access.
      </p>
      <h3 className="text-xl mt-4">Secret Management</h3>
      <p>
        Encryption keys are managed via AWS Key Management System (KMS).
        Customers can be granted access to delete their keys which immediately
        revokes all access to their data. Application secrets are encrypted and
        stored in AWS Secrets Manager.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Product Security</h2>
      <h3 className="text-xl mt-4">Penetration Testing</h3>
      <p>
        Kernel engages third parties to perform penetration testing at least
        annually or at the request of our customers. All areas of the Kernel
        product are in-scope for these assessments and any findings are
        remediated immediately.
      </p>
      <h3 className="text-xl mt-4">Vulnerability Scanning</h3>
      <p>
        Kernel requires vulnerability scanning at key stages of our Software
        Development Lifecycle:
        <ul>
          <li>Static analysis testing of code during pull requests</li>
          <li>
            Software composition analysis to identify known vulnerabilities in
            dependencies
          </li>
        </ul>
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">Enterprise Security</h2>
      <h3 className="text-xl mt-4">Endpoint Protection</h3>
      <p>
        All corporate devices are centrally managed and equipped with mobile
        device management software and anti-malware protection. We use MDM
        software to enforce secure configuration of endpoints such as disk
        encryption, screen lock configuration, and user access.
      </p>
      <h3 className="text-xl mt-4">Secure Remote Access</h3>
      <p>
        Kernel secures remote access to internal resources using AWS Client VPN
        built on OpenVPN. We also use ad and malware-blocking DNS servers to
        protect employees and their endpoints while browsing the internet.
      </p>
      <h3 className="text-xl mt-4">Security Education</h3>
      <p>
        Kernel provides comprehensive security training to all employees upon
        onboarding and annually through education modules within our Learning
        Management System (LMS).
      </p>
      <h3 className="text-xl mt-4">Identity and Access Management</h3>
      <p>
        Kernel uses JumpCloud as our identity provider and for access
        management. We enforce phishing-resistant authentication factors using
        SAMLv2 combined with multiple factors whenever possible. Kernel
        employees are granted access to applications based on their role and
        business needs and are automatically deprovisioned upon the termination
        of their employment. Further access must be approved according to
        company policies for each application.
      </p>
    </div>
  );
}
